import { css } from "@emotion/react";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Redirect, useParams } from "react-router-dom";
import type { LocationDescriptor } from "history";

import { LoaderLayout } from "../../../components/atoms/loader/LoaderLayout";
import { ticketActions } from "../../../modules/ticket";
import { convertMapToValues } from "../../../utility";
import type { Store } from "../../../store";

export const EventGoodsItemFromCapsuleId: React.FC = () => {
  const displayEvent = useSelector((state: Store) => state.event.displayEvent);
  const goodsMap = useSelector((state: Store) => state.ticket.eventGoodsMap);
  const location = useSelector((state: Store) => state.router.location);
  const { eventId, capsuleId } = useParams<{
    eventId: string;
    capsuleId: string;
  }>();

  const [newLocation, setNewLocation] = useState<LocationDescriptor>();

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(
      ticketActions.fetchEventGoods.started({ eventId: displayEvent.eventId })
    );
    return () => {
      dispatch(ticketActions.clearStateByKey("eventGoodsMap"));
    };
  }, [dispatch, displayEvent.eventId]);

  useEffect(() => {
    if (goodsMap && capsuleId) {
      const goods = convertMapToValues(goodsMap);
      const targetCapsule = goods.find(
        (el) => el.eid === eventId && el.class === Number(capsuleId)
      );
      if (!targetCapsule) return;

      // URL末尾のカプセルをグッズに置換
      // `/events/:eventId/capsule/:capsuleId` -> `/events/:eventId/goods/:goodsName`
      setNewLocation({
        ...location,
        pathname: `/events/${eventId}/goods/${targetCapsule.className}`,
      });
    }
  }, [capsuleId, eventId, goodsMap, location]);

  if (!newLocation) {
    return (
      <div
        id="contents"
        css={css`
          margin: 0 auto;
        `}
      >
        <LoaderLayout />
      </div>
    );
  }

  return <Redirect to={newLocation} />;
};
